const SET_NAV_BAR_DATA = 'SET_NAV_BAR_DATA';

export const NAV_BAR_TYPES = {
    SET_NAV_BAR_DATA
};
